import { IVaccinationTypeReducer, IVaccinationType } from 'models/VaccinationType'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { updateArray, deleteFromArray } from 'helpers/helperFunctions'
import {
  GetVaccinationTypes,
  VaccinationTypesFetching,
  UpdateVaccinationType,
  DeleteVaccinationType,
} from './actions'

const initialState: IVaccinationTypeReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const vaccinationTypesReducer = (
  state = initialState,
  action: Action
): IVaccinationTypeReducer => {
  if (isType(action, GetVaccinationTypes)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, UpdateVaccinationType)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IVaccinationType>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, DeleteVaccinationType)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<IVaccinationType>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, VaccinationTypesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
